import { render } from "./Old_UP_Non.vue?vue&type=template&id=5ef63a46"
import script from "./Old_UP_Non.vue?vue&type=script&lang=js"
export * from "./Old_UP_Non.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/Old_UP_Non.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ef63a46"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ef63a46', __exports__)) {
    api.reload('5ef63a46', __exports__)
  }
  
  module.hot.accept("./Old_UP_Non.vue?vue&type=template&id=5ef63a46", () => {
    api.rerender('5ef63a46', render)
  })

}


export default __exports__